import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function OfferSection() {
  return <section className="py-14 px-4 md:px-6 relative bg-[#0a0e1a]" data-id="element-104">
      <div className="max-w-5xl mx-auto" data-id="element-105">
        <FadeIn data-id="element-106">
          <div className="text-center mb-10" data-id="element-107">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-108">
              Lo que recibirás hoy
            </h2>
            <div className="w-24 h-1 bg-cyan-500 mx-auto rounded-full" data-id="element-109"></div>
          </div>
        </FadeIn>

        <div className="bg-slate-800/40 border border-slate-700/50 rounded-3xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-8" data-id="element-110">
          <FadeIn delay={0.1} className="w-full md:w-1/3 flex justify-center" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/5exoYmt9VozeqzVQchaov6/PORTADA.png" alt="Ebook Cover" className="w-full max-w-[250px] rounded-lg shadow-[0_0_30px_rgba(0,212,255,0.2)] border border-slate-700" data-id="element-112" />
          </FadeIn>

          <FadeIn delay={0.2} className="w-full md:w-2/3 space-y-6" data-id="element-113">
            <div className="inline-block px-3 py-1 rounded bg-cyan-500/20 text-cyan-400 text-sm font-bold tracking-wider border border-cyan-500/30" data-id="element-114">
              EBOOK DIGITAL
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-115">
              Protocolo 7 Días — El Interruptor de Energía
            </h3>
            <p className="text-lg text-slate-300" data-id="element-116">
              El paso a paso exacto para limpiar tu enfoque y desinflamar tu
              cuerpo de forma natural.
            </p>

            <ul className="space-y-4 pt-4" data-id="element-117">
              <li className="flex items-start gap-3" data-id="element-118">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 shrink-0 mt-0.5" data-id="element-119" />
                <span className="text-slate-300" data-id="element-120">
                  Instrucciones claras y directas, sin relleno.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-121">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 shrink-0 mt-0.5" data-id="element-122" />
                <span className="text-slate-300" data-id="element-123">
                  Aplicable desde el primer día.
                </span>
              </li>
            </ul>

            <div className="pt-6 mt-6 border-t border-slate-700/50" data-id="element-124">
              <p className="text-slate-400 line-through text-lg" data-id="element-125">
                Valor real: $37 USD
              </p>
              <p className="text-3xl font-bold text-cyan-400" data-id="element-126">Hoy: $6.99 USD</p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}